
import { i18nText } from '@/locales';

import Api from '@/repository/api';
import {Component, Vue} from 'vue-property-decorator';
import PageTitle from "@/UI/components/common/PageTitle.vue";
import {ITableColumn} from "@/entity/table/table.types";
import {TablesStore} from "@/store/modules/Tables";
import CounterpartiesAddForm from "@/form/finance/counterparties/CounterpartiesAddForm";
import CounterpartiesUpdateForm from "@/form/finance/counterparties/CounterpartiesUpdateForm";
import CounterpartiesAddComponent from "@/UI/components/forms/finance/counterparties/CounterpartiesAddComponent.vue";
import CounterpartiesUpdateComponent
  from "@/UI/components/forms/finance/counterparties/CounterpartiesUpdateComponent.vue";
import {CounterpartiesStore} from "@/store/modules/Counterparties";
import {CounterpartiesTypeStore} from "@/store/modules/CounterpartiesType";
import ModalWrapper from "@/UI/components/common/ModalWrapper.vue";
import {ICounterpartiesListItem} from "@/entity/finance/counterparties/counterparties.types";
import {
  ICounterpartiesType,
} from "@/entity/finance/counterparties/counterpartiesType.types";
import {mixins} from 'vue-class-component'
import {ProxyDataForm} from '@/UI/components/Helpers/ProxyDataForm'
import {checkUserRole, getUserData} from '@/router/Lib/helper';
import {CounterpartiesMix} from '@/UI/mixins/CounterpartiesMix';
import {ProxyTableData} from "@/UI/components/Helpers/ProxyTableData";
import {ProxyGetData} from "@/UI/components/Helpers/getData";
import {appPaginationStore} from "@/store/modules/appPagination";
import {getStudioId} from "@/UI/lib/state";
import SortComponent from "@/UI/components/Helpers/components/SortComponent.vue"

@Component({
  components: {ModalWrapper, PageTitle, CounterpartiesAddComponent, CounterpartiesUpdateComponent, SortComponent}
})
export default class Counterparties extends mixins(ProxyTableData, CounterpartiesMix, ProxyGetData) {
  form = new CounterpartiesAddForm();
  updateForm = new CounterpartiesUpdateForm();
  // counterparty: ICounterpartiesListItem | null = null;
  searchText = '';
  searchedColumn = '';
  showAddModal = false;
  showUpdateModal = false;
  filterData: any;
  fileList: any[] = [];
  importFile: File | null = null;
  uploading = false;
  exporting = false;
  saving = false;

  get canManage(): boolean {
    return Vue.auth.check(['owner', 'admin']);
  }

  async created(): Promise<void> {
    try {
      this.proxyFilter = {salon_id: getStudioId(this)};
      appPaginationStore.setCurrent(1);
      await this.sortedData('desc', {dataIndex: 'created_at'});
    } catch (e) {
      console.log(e)
    } finally {
      this.tableLoad = true;
    }
  }

  get columns(): ITableColumn[] {
    return TablesStore.financeCounterparties;
  }

  // get counterparties(): ICounterparties | null {
  //   return CounterpartiesStore.counterparties;
  // }

  async handleAddModal(visible: boolean): Promise<void> {
    if (visible) {
      this.form = new CounterpartiesAddForm();
      this.form.setFormData(await this.counterpartiesTypes(), getStudioId(this));
    }
    this.showAddModal = visible;
  }

  handleUpdateModal(visible: boolean): void {
    this.showUpdateModal = visible;
  }

  async show(counterparty: ICounterpartiesListItem): Promise<void> {
    this.updateForm.setFormData(counterparty, await this.counterpartiesTypes());
    this.handleUpdateModal(true);
  }

  async submit(): Promise<void> {
    if (this.saving) return;
    this.saving = true;
    try {
      if (await this.form.submit(CounterpartiesStore.create)) {
        this.showAddModal = false;
        appPaginationStore.setCurrent(1);
        if (this.pager) this.pager.current = 1;
        await this.sortedData('desc', {dataIndex: 'created_at'});
      }
    } catch (error) {
      this.$message.error(error.response?.data?.message || error.message);
    } finally {
      this.saving = false;
    }
  }

  async updateSubmit(): Promise<void> {
    if (this.saving) return;
    this.saving = true;
    try {
      if (await this.updateForm.submit(CounterpartiesStore.update)) {
        this.showUpdateModal = false;
        await this.getData();
      }
    } catch (error) {
      this.$message.error(error.response?.data?.message || error.message);
    } finally {
      this.saving = false;
    }
  }

  async counterpartiesTypes(data?: Record<string, any>): Promise<ICounterpartiesType[]> {
    if (!CounterpartiesTypeStore.items) {
      await CounterpartiesTypeStore.fetchAll();
    }

    if (CounterpartiesTypeStore.items) {
      return CounterpartiesTypeStore.items;
    } else {
      return [];
    }
  }

  beforeUpload(file: any): boolean {
    this.uploading = true;
    this.importFile = file;
    this.fileList = [file];
    this.confirmUploadFile();
    return false;
  }

  async uploadFile(): Promise<void> {
    if (!this.importFile) return;
    const res = await CounterpartiesStore.import(this.importFile);
    if (res) {
      if (res.status) {
        //await this.fetchTableItems();
        await this.getData();
        this.$message.success(res.response);
        // this.setPaginationTotal();
      } else {
        this.$message.error(res.response);
      }
    }
    this.uploading = false;
  }

  async downloadFile(): Promise<void> {
    this.exporting = true;
    try {
      const {data} = await Api.get('/finance/counterparties/export', {params: {salon_id: getStudioId(this)}, responseType: 'blob'});
      const url = URL.createObjectURL(data);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'counterparties.xlsx';
      link.click();
      window.setTimeout(() => URL.revokeObjectURL(url), 1000);
    } catch (error) {
      this.$message.error(i18nText('Не удалось выгрузить контрагентов.'));
    } finally {
      this.exporting = false;
    }
  }

  confirmUploadFile(): void {
    if (window.confirm(i18nText("Файл готов к загрузке. Продолжить загрузку?"))) {
      this.uploadFile();
    } else {
      this.uploading = false;
      this.fileList = [];
      this.importFile = null;
    }
  }

  triggerUpload(): void {
    let elem = this.$refs.uploadEvent;
    if (elem && '$el' in elem) {
      elem.$el?.querySelector('input')?.click();
    }
  }

  async setFilter({by, sort}: { by: string; sort: any }): Promise<void> {
    await this.sortedData(by, {dataIndex: sort.dataIndex})
  }
}
